import { Paper, Typography, Button, Stack } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 3, sm: 4 },
        textAlign: "center",
        borderRadius: 2,
        borderStyle: "dashed",
        borderWidth: 1,
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        <InboxOutlinedIcon sx={{ fontSize: 48, color: "text.disabled" }} />
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
            {description}
          </Typography>
        )}
        {actionLabel && onAction && (
          <Button variant="contained" onClick={onAction} sx={{ mt: 1.5 }}>
            {actionLabel}
          </Button>
        )}
      </Stack>
    </Paper>
  );
}
